/**
 * CareerAI（ヤギコンシェルジュ）の計測。
 *
 * gtag と DB ミラーの二重送信、および v-html で描いたリンクのクリック検知。
 * SFC から切り出したのは**テストのため**でもある（以前は SFC ソースを
 * 正規表現で切り出して eval していて、Composition 化で壊れた）。
 */
import careerAIClient from '@/services/career-ai-client'

/* eslint-disable @typescript-eslint/no-explicit-any */

export type TrackEvent = (eventName: string, params?: any) => void

/**
 * 計測関数を作る。uuid / session は送信時点の値を使うため getter で受け取る。
 *
 * gtag は同期、DB ミラーは fire-and-forget。uuid か session が無いときは
 * DB へは送らない（セッション未開始の計測は突き合わせできないため）。
 */
export function createTrackEvent(
  getUuid: () => string,
  getSessionId: () => string
): TrackEvent {
  return (eventName: string, params?: any): void => {
    const w = typeof window !== 'undefined' ? (window as any) : null
    if (w && typeof w.gtag === 'function') {
      try {
        w.gtag('event', eventName, params || {})
      } catch (_) {
        // 計測の失敗で本処理を止めない
      }
    }
    const uuid = getUuid()
    const sessionId = getSessionId()
    if (uuid && sessionId) {
      careerAIClient.trackEvent(uuid, sessionId, eventName, params || {})
    }
  }
}

/**
 * 吹き出し内のクリックからリンク先を取り出す。
 *
 * `v-html` で注入した要素には個別に @click を付けられないので、
 * 吹き出し単位のデリゲートで `closest('a')` を辿る。リンク以外なら null。
 */
export function extractLinkHref(e: any): string | null {
  const a = e && e.target && e.target.closest ? e.target.closest('a') : null
  return (a && a.getAttribute('href')) || null
}
